import { Icon, Message } from 'semantic-ui-react'

interface Props {
    permitTypeId: number;
}

export default function HOVMessage({permitTypeId}: Props) {
    return (
        <>
            {permitTypeId === 3 && 
                <Message icon color='yellow'>
                    <Icon name='exclamation' />
                    <Message.Content>
                        <Message.Header>Important</Message.Header>
                        HOV Number for Public Tranit Vehicles Only.
                    </Message.Content>
                </Message>
            }
        </>
    );
}